/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RegimenDrug from './regimen-drug';
import RegimenDrugDetail from './regimen-drug-detail';
import RegimenDrugUpdate from './regimen-drug-update';
import RegimenDrugDeleteDialog from './regimen-drug-delete-dialog';

const RegimenDrugRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RegimenDrug />} />
    <Route path="new" element={<RegimenDrugUpdate />} />
    <Route path=":id">
      <Route index element={<RegimenDrugDetail />} />
      <Route path="edit" element={<RegimenDrugUpdate />} />
      <Route path="delete" element={<RegimenDrugDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RegimenDrugRoutes;
